import { Message } from 'element-ui';
import vantArea from '../../views/customer/template/vant.area';

const url = {
  // 全局接口地址前缀
  A() {
    if (window.location.href.indexOf('gg.deeptel.com.cn') > 0) {
      // return 'https://beauty.duofriend.com';
      // return 'https://nbyangzi.deeptel.com.cn';
      return 'https://yangzi.deeptel.com.cn';
    }
    return window.location.origin;
  },
  // 获取链接所带参数方法
  B(name) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
  // 获取链接所带参数方法--自带参数
  C(name, val) {
    const reg = new RegExp(`(^|&)${name}=([^&]*)(&|$)`);
    const r = val.match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
  getUrlKey(name) {
    return (
      decodeURIComponent(
        // eslint-disable-next-line no-restricted-globals, no-sparse-arrays, no-useless-concat
        (new RegExp(`[?|&]${name}=` + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(
          /\+/g,
          '%20'
        )
      ) || null
    );
  },
  // 验证手机号码是否正确
  CheckPhone(val) {
    const value = `${val}`;
    const newVal = value.replace(/^\s+|\s+$/gm, '');
    const reg = /^(1[3-9][0-9])\d{8}$/;
    return !!reg.test(newVal);
  },
  collectively() {
    return window.sessionStorage.collectively;
  },
  // 获取提成是否可以修改
  getPercentage() {
    return window.sessionStorage.isPercentage != 1;
  },
  // 获取套餐过期时间是否可以修改
  getPackageTime() {
    return window.sessionStorage.isPackageTime == 1;
  },
  // 根据付款码返回对应的支付方式
  returnPayBarCodeType(val) {
    const AlipayReg = /^(((2[5-9])|(30))\d{14,22})$/; // 支付宝付款码条形码规则：由25-30开头，长度为16-24位的纯数字
    const WeChatReg = /^((1[0-5])\d{16})$/; // 微信付款码条形码规则：18位纯数字，以10、11、12、13、14、15开头
    if (!(/(^[1-9]\d*$)/.test(val))) { // 正则校验  return的值根据自己项目自行调整  第一个判断是否为正整数数字
      console.log('请输入正确的付款码');
      return 0;
    } if (AlipayReg.test(val)) {
      console.log('微信');
      return 1;
    } if (WeChatReg.test(val)) {
      console.log('微信');
      return 2;
    }
    console.log('翼支付');
    return 3;
  },
  // 时间戳格式转换成时间格式  time--yyyy-MM-dd HH:mm:ss
  D(ldate, time) {
    let fmt = time;
    if (!Number(ldate * 1)) {
      if (ldate.indexOf('-') > -1 || ldate.indexOf('T') > -1) {
        if (fmt == 'yyyy-MM-dd') {
          return ldate.substring(0, 10);
        } if (fmt == 'yyyy-MM-dd HH:mm') {
          return ldate.substring(0, 16).replace('T', ' ');
        }
        return ldate.substring(0, 19).replace('T', ' ');
      }
    }
    const newDate = parseInt(ldate, 10);
    const date = new Date(newDate);
    const o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours() % 12 == 0 ? 12 : date.getHours() % 12, // 小时
      'H+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      S: date.getMilliseconds() // 毫秒
    };
    const week = {
      0: '/u65e5',
      1: '/u4e00',
      2: '/u4e8c',
      3: '/u4e09',
      4: '/u56db',
      5: '/u4e94',
      6: '/u516d'
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length));
    }
    if (/(E+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, ((RegExp.$1.length > 1) ? (RegExp.$1.length > 2 ? '/u661f/u671f' : '/u5468') : '') + week[`${date.getDay()}`]);
    }
    for (const k in o) {
      if (new RegExp(`(${k})`).test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : ((`00${o[k]}`).substr((`${o[k]}`).length)));
      }
    }
    return fmt;
  },
  returnRoomOrBed() {
    return window.sessionStorage.tidyStatus == 1 ? '房间' : window.sessionStorage.tidyStatus == 2 ? '床位' : '台位';
  },
  // 手机号码中间四位设置为星号
  starPhone(phoneNum) {
    if (window.sessionStorage.isHidePhone == 1) {
      const str = String(phoneNum);
      return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    }
    return phoneNum;
  },
  // 返回顶部
  backTop() {
    $('.right-content').animate({
      scrollTop: '0'
    }, 500);
  },
  checkPower(val, status) {
    const arr = JSON.parse(sessionStorage.getItem('menusList'));
    if (!arr.find((data) => data.iDenTi === val)) {
      if (status == 2) return false;
      Message({ type: 'warning', message: '暂无权限，请联系管理员分配权限' });
      return false;
    }
    return true;
  },
  // 获取一周时间
  G(num, fmt) {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * num);
    const startTime = this.D(start.getTime(), fmt);
    const endTime = this.D(end.getTime(), fmt);
    if (num == 1) {
      return endTime;
    } if (num == 7) {
      return [startTime, endTime];
    }
  },
  // 取值  1取整数  2取小数
  getValue(num, val) {
    let newVal = val;
    if (!newVal) newVal = '0.00';
    newVal = (newVal * 1).toFixed(2);
    const str = newVal.split('.');
    if (num == 1) {
      return str[0];
    }
    return `.${str[1]}`;
  },
  // 获取数组里面最小值
  getMinVal(item, name) {
    let min = item[0][name] * 1;
    item.forEach((v) => {
      const cur = v[name] * 1;
      (min > cur) ? (min = cur) : (min = min);
    });
    return min;
  },
  // 播放语音信息
  playAudio() {
    const audio = document.getElementById('audio');
    audio.play();
  },
  // 判断是PC还是手机
  pcOrMobile() {
    if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
      return 'mobile';
    }
    return 'pc';
  },
  // 收起键盘事件
  keyboardBlur() {
    const status = this.pcOrMobile();
    if (status == 'mobile') {
      $('input').blur();
    }
  },
  // 图片放大效果
  enlarge(imgUrl) {
    if (imgUrl) {
      $('#enlarge img').attr('src', imgUrl);
      $('#enlarge').addClass('is-visible');
    } else {
      $('#enlarge').removeClass('is-visible');
    }
  },
  // 文字过长的显示和隐藏
  textShow(e, fontSize) {
    const target = e.currentTarget.innerText;
    // 中文和中文字符的匹配
    const re = /[\u4E00-\u9FA5_\u3002\uff1b\uff0c\uff1a\u201c\u201d\uff08\uff09\u3001\uff1f\u300a\u300b]/g;
    let Chinese;
    if (target.match(re)) {
      Chinese = target.match(re).length;
    } else {
      Chinese = 0;
    }

    const notChinese = target.length - Chinese;
    return !(((Chinese * (fontSize || 14) + notChinese * (fontSize ? fontSize / 2 : 7)) > e.currentTarget.clientWidth));
  },
  // 计算天数  多少个月后的总天数
  totalDays(val) {
    const day = new Date();
    let y = day.getFullYear() * 1;
    let m = day.getMonth() * 1;
    let days = 0;
    for (let i = 0; val > i; i++) {
      m++;
      if (m > 12) {
        m = 1;
        y++;
      }
      if ((m == 2 && y % 4 == 0 && y % 100 != 100) || y % 400 == 0) {
        days += 29;
      } else if (m == 2 && y % 4 != 0) {
        days += 28;
      } else if (m == 1 || m == 3 || m == 5 || m == 7 || m == 8 || m == 10 || m == 12) {
        days += 31;
      } else if (m == 2 || m == 4 || m == 6 || m == 9 || m == 11) {
        days += 30;
      }
    }
    return days;
  },
  // 把vant省市区数据重组成element可以用的数据
  returnCityData() {
    const areaArr = vantArea.default;
    const r1 = [];
    for (let a = 0; a < 999999; a++) {
      if (areaArr.province_list[a]) {
        const obj1 = {};
        obj1.value = `${a}`;
        obj1.label = areaArr.province_list[a];
        obj1.children = [];
        if (areaArr.province_list[a] !== '海外') {
          for (let b = a; a + 9999 > b; b++) {
            if (areaArr.city_list[b]) {
              const obj2 = {};
              obj2.value = `${b}`;
              obj2.label = areaArr.city_list[b];
              if (areaArr.province_list[a] !== '海外') {
                obj2.children = [];
              }
              for (let c = b; b + 99 > c; c++) {
                if (areaArr.county_list[c]) {
                  const obj3 = {};
                  obj3.value = `${c}`;
                  obj3.label = areaArr.county_list[c];
                  obj2.children.push(obj3);
                }
              }
              obj1.children.push(obj2);
            }
          }
          r1.push(obj1);
        } else {
          for (let d = a; a + 99999 > d; d++) {
            if (areaArr.city_list[d]) {
              const obj2 = {};
              obj2.value = d;
              obj2.label = areaArr.city_list[d];
              obj1.children.push(obj2);
            }
          }
          r1.push(obj1);
        }
      }
    }
    return r1;
  },
  // 把vant省市区数据重组成小程序可以用的数据
  returnCityDataTwo() {
    const areaArr = vantArea.default;
    const r2 = [{
      province_list: []
    },
    {
      city_list: []
    },
    {
      county_list: []
    }
    ];
    for (let a = 0; a < 999999; a++) {
      if (areaArr.province_list[a]) {
        const obj1 = {};
        obj1.value = `${a}`;
        obj1.label = areaArr.province_list[a];
        r2[0].province_list.push(obj1);
      }
      if (areaArr.city_list[a]) {
        const obj2 = {};
        obj2.value = `${a}`;
        obj2.label = areaArr.city_list[a];
        r2[1].city_list.push(obj2);
      }
      if (areaArr.county_list[a]) {
        const obj3 = {};
        obj3.value = `${a}`;
        obj3.label = areaArr.county_list[a];
        r2[2].county_list.push(obj3);
      }
    }
    return r2;
  },
  // tabs定位问题解决方案
  resetTabActivePosition($el) {
    setTimeout(() => {
      const activeEl = $el.querySelector('.el-tabs__item.is-active');
      const lineEl = $el.querySelector('.el-tabs__active-bar');
      const style = getComputedStyle(activeEl);
      const pl = (style.paddingLeft.match(/\d+/) ? (style.paddingLeft.match(/\d+/)[0] * 1) : 0);
      const pr = (style.paddingRight.match(/\d+/) ? (style.paddingRight.match(/\d+/)[0] * 1) : 0);
      const w = (style.width.match(/\d+/) ? (style.width.match(/\d+/)[0] * 1) : 0);
      lineEl.style.transform = `translateX(${activeEl.offsetLeft + pl}px)`;
      lineEl.style.width = `${w - pl - pr}px`;
    }, 100);
  },
  // 环境 测试test 堡垒pre 正式prod
  judgeEnvironment() {
    const { href } = window.location;
    if (href.includes('duofriend')) return 'prod';
    if (href.includes('https://nb')) return 'pre';
    return 'test';
  },
  // 6.6 返回活动颜色/名称/简称  val=1返回颜色，val=2返回名称，val=3返回简称
  getActivity(type, val) {
    if (val == 1) {
      return type == 1 ? 'color: #FF4040;' : type == 2 ? 'color: #F9B600;' : type == 3 ? 'color: #4086FF;' : 'color: #FF6740;';
    } if (val == 2) {
      return type == 1 ? '特价促销' : type == 2 ? '定时打折' : type == 3 ? '买赠活动' : '满赠活动';
    } if (val == 3) {
      return type == 1 ? '特价' : type == 2 ? '定折' : type == 3 ? '买赠' : '满赠';
    } if (val == 4) {
      return type == 1 ? '#FF4040' : type == 2 ? '#F9B600' : type == 3 ? '#4086FF' : '#FF6740';
    }
  },
  // 6.6返回订单类型具体的名称
  getOrderTypeName(type) {
    const name = type == 1 ? '服务订单' : type == 2 ? '快捷收银订单' : type == 3 ? '购买套餐订单' : type == 4 ? '直接划扣订单' : type == 5 ? '房间订单' : type == 6 ? '预约订单' : type == 7 ? '服务订单&预约订单' : type == 8 ? '服务订单&房间订单' : '服务订单&预约订单&房间订单';
    return name;
  },
  // 6.7预约状态与颜色  type==1为输出文字   type==2为输出颜色
  getBespeakVal(val, type) {
    const status = (val == '已预约-待服务' ? 0 : val == '已预约-服务中' ? 1 : val == '已完成' ? 2 : val == '已预约-预约超时' ? 3 : val == '已预约-待确认' ? 4 : val == '已预约' ? 5 : val == '已取消-商家取消' ? -1 : val == '已取消-预约过期' ? -2 : val == '已取消-用户取消' ? -3 : val == '已取消-商家拒绝' ? -4 : val == '已取消' ? -5 : val);
    if (type == 1) {
      return status == 0 ? '已预约-待服务' : status == 1 ? '已预约-服务中' : status == 2 ? '已完成' : status == 3 ? '已预约-预约超时' : status == 4 ? '已预约-待确认' : status == 5 ? '已预约' : status == -1 ? '已取消-商家取消' : status == -2 ? '已取消-预约过期' : status == -3 ? '已取消-用户取消' : status == -4 ? '已取消-商家拒绝' : '已取消';
    }
    return (status == 0 || status == 1 || status == 3 || status == 4 || status == 5) ? 'color: #FA5555;' : status == 2 ? 'color: #67C23A;' : '';
  },
  calculationTime(mss) {
    const day = Math.floor(mss / 60 / 24);
    const hour = Math.floor(mss / 60 - day * 24);
    const minute = Math.floor(mss - day * 24 * 60 - hour * 60);
    if (day > 0) {
      return `${day}天${hour}小时${minute}分钟`;
    } if (hour > 0) {
      return `${hour}小时${minute}分钟`;
    } if (minute > 0) {
      return `${minute}分钟`;
    }
    return '--';
  }
};

export default url;
